import { render } from "./JsonEditor.vue?vue&type=template&id=963752da&scoped=true&ts=true"
import script from "./JsonEditor.vue?vue&type=script&lang=ts"
export * from "./JsonEditor.vue?vue&type=script&lang=ts"

import "./JsonEditor.vue?vue&type=style&index=0&id=963752da&scoped=true&lang=scss"

import exportComponent from "/Users/otto/Code/projects/bubbly/doo/apps/builder-legacy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-963752da"]])

export default __exports__